import { gql } from "@apollo/client";

export default gql`
  mutation CancelProductStackRequest($requestId: ObjectId!) {
    cancelProductStackRequest(requestId: $requestId)
  }
`;
